import { render, staticRenderFns } from "./ChatMemberAvatar.vue?vue&type=template&id=035a1873&"
import script from "./ChatMemberAvatar.vue?vue&type=script&lang=js&"
export * from "./ChatMemberAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ChatMemberAvatar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports